<template>
  <section class="log-out d-none d-lg-flex">

    <div class="log-out-trigger" :class="{ 'menu-active': isSubMenuActive }" @click="toggleMenu">
      <div class="log-out-user">
        <h3>{{ user.name }}</h3>
        <p>{{ companyName }}</p>
        <p class="user-email">{{ user.email }}</p>
      </div>
      <div class="log-out-image">
        <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 57.746 55"
          style="opacity: 1 !important; filter: none !important;">
          <path
            d="M1448.872-595.042a29.942,29.942,0,0,1-14.843-3.9,15.341,15.341,0,0,1,14.844-10.758,15.342,15.342,0,0,1,14.844,10.757A29.946,29.946,0,0,1,1448.872-595.042Zm18.152-6.108v0a18.809,18.809,0,0,0-10.61-10.756,12.667,12.667,0,0,0,5.93-10.616c0-7.068-6.043-12.819-13.47-12.819s-13.471,5.751-13.471,12.819a12.666,12.666,0,0,0,5.93,10.616,18.817,18.817,0,0,0-10.611,10.755A26.889,26.889,0,0,1,1420-622.522c0-15.151,12.952-27.478,28.872-27.478s28.874,12.327,28.874,27.478a26.9,26.9,0,0,1-10.72,21.37Zm-18.151-12.234a9.4,9.4,0,0,1-9.618-9.154,9.4,9.4,0,0,1,9.618-9.152,9.4,9.4,0,0,1,9.617,9.152A9.4,9.4,0,0,1,1448.874-613.384Z"
            transform="translate(-1420 650)"
            :fill="isSubMenuActive ? '#FFA141' : '#5ddead'"
            style="opacity: 1 !important; filter: none !important;"
          />
        </svg>
        <v-icon size="18" color="#555">mdi-chevron-down</v-icon>
      </div>
    </div>

    <transition name="fade">
      <div class="custom-user-menu" v-if="isSubMenuActive" v-click-outside="closeMenu">

        <div
          class="menu-option"
          :class="{ 'menu-option--active': isRouteActive('profile') }"
          @click="goTo('profile')"
        >
          <v-icon size="18">mdi-account-outline</v-icon>
          <span>Mi perfil</span>
        </div>

        <div
          class="menu-option"
          :class="{ 'menu-option--active': isRouteActive('configuration') }"
          @click="goTo('configuration')"
          id="configuration"
        >
          <v-icon size="18">mdi-cog-outline</v-icon>
          <span>Configuración</span>
        </div>

        <div
          class="menu-option"
          :class="{ 'menu-option--active': isRouteActive('administracion-usuarios') }"
          v-if="isAdmin"
          @click="goTo('administracion-usuarios')"
        >
          <v-icon size="18">mdi-account-multiple-outline</v-icon>
          <span>Administrar usuarios</span>
        </div>

        <div class="menu-option" @click="logout">
          <v-icon size="18">mdi-logout</v-icon>
          <span>Salir de mi cuenta</span>
        </div>
      </div>
    </transition>

  </section>
</template>

<script>
import { mapState } from "vuex";
import TourService, {STORAGE_KEY} from "@/services/tourService";
import { stepsMenuConfiguration, userMenuTourMeta } from "./OB-UserMenu";

export default {
  name: "UserMenu",

  data() {
    return {
      isSubMenuActive: false,
    };
  },

  computed: {
    ...mapState({
      user: (state) => state.userProfile.userProfile,
      isAdmin: (state) => state.userProfile.userProfile.isAdmin,
    }),

    isProfileReady() {
      return !!(this.user?.profileComplete && this.user?.client && this.user?.status === 'ACTIVE')
    },

    companyName() {
      if (!this.user.client) return "Nombre de empresa";
      return this.user.client.documentTypeId === 1
        ? this.user.client.name
        : this.user.client.businessName;
    },
  },
  mounted (){
    const tours = JSON.parse(localStorage.getItem(STORAGE_KEY))
    
    setTimeout(() => {
      const tour = tours?.tutorial_configuracion_submenu
  
      if(!tour || (tour && !tour?.completed && tour?.lastStep == 1))
      {
        this.isSubMenuActive = true;
      }
    }, 300);
  },

  methods: {
    toggleMenu() {
      this.isSubMenuActive = !this.isSubMenuActive;
    },

    closeMenu() {
      //para detectar si hay una capa del onboarding activa y no cerrar el menú en ese caso
      const layerIntrojs = document.querySelector('.introjs-helperLayer');
      if(layerIntrojs){
        return;
      }
      this.isSubMenuActive = false;
    },

    goTo(route) {
      this.$router.push({ name: route }).catch(() => {});
      this.isSubMenuActive = false;
    },

    logout() {
      this.isSubMenuActive = false;
      this.$store.dispatch("logout");
      this.$router.push({ name: "login" });
    },

    isRouteActive(routeName) {
      return this.$route.name === routeName;
    },
  },
  watch:{
    isSubMenuActive(newVal){
      if(newVal && this.isProfileReady){
        TourService.start({
          tourName: 'tutorial_configuracion_submenu',
          steps: stepsMenuConfiguration,
          breakTour: true,
          breakStep: 1,
          releaseDate: userMenuTourMeta.releaseDate,
          showTo: userMenuTourMeta.showTo,
        })
      } 
    }
  }
};
</script>

<style lang="scss" scoped>
.log-out {
  position: relative;
}

.log-out-trigger {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 8px;
  transition: background 0.2s;
}

.log-out-trigger:hover {
  background: rgba(0, 0, 0, 0.05);
}

.log-out-image  {
  display: flex;
  flex-direction: column;
}

.log-out-image svg {
  width: 42px;
  height: 42px;
  opacity: 1 !important;
  filter: none !important;
}

.log-out-image svg path {
  opacity: 1 !important;
  filter: none !important;
}

.log-out-user h3 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #333;
  white-space: nowrap;
  font-family: $lexend-font;
}

.log-out-user p {
  margin: 0;
  font-size: 12px;
  color: #777;
  white-space: nowrap;
  font-family: $lexend-font;
}

.custom-user-menu {
  position: absolute;
  top: 60px;
  right: 0;
  width: 250px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  padding: 8px 0;
  z-index: 999;
}

.menu-option {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 20px;
  cursor: pointer;
  font-size: 14px;
  color: #333;
  transition: background 0.2s, color 0.2s;
  font-family: $lexend-font;
}

.menu-option:hover {
  background: #f5f5f5;
}

.menu-option--active {
  color: #5CC597;
  font-weight: 600;

  .v-icon {
    color: #5CC597 !important;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>

<style lang="scss" scoped>
  // fix branch fusion feat/configuration-menu - Qa
  .log-out {
    margin-top: 0 !important;

    .log-out-trigger {
      padding: 0px 8px;

      .log-out-image  {
        img {
          width: 48px;
          height: auto;
          border-radius: unset;
        }
      }
    }
  }
</style>